@if (leg.official === false &&
     leg.type_code !== 'HOME_CORNERS_OU' &&
     leg.type_code !== 'AWAY_CORNERS_OU' &&
     leg.type_code !== 'TOT_CORNERS_OU' &&
     leg.type_code !== 'TOT_CARDS_OU' &&
     leg.type_code !== 'OVER_UNDER') {
  <div class="units">
    <div class="unit-selections-2 sep">
      @for (result of leg.selections | orderBy:'display_order'; track $index; let i = $index; let last = $last) {
        <div class="unit-item-2 sep"
             [ngClass]="{'last': leg.selections.length <= 2 || (leg.selections.length % 2 === 0 && ((leg.selections.length - 1 === i) || (leg.selections.length - 1 === i + 1))) || (leg.selections.length % 2 !== 0 && last)}">
          <div class="breakdown-score-2">
            <span [transloco]="'selections.' + result.name" [translocoParams]="{defaultValue: result.name}"></span>
          </div>
          <div class="breakdown-units-2">
            <span class="mr-0.5">{{getUnits(result.unit_distributions) | formatUnits }}</span>
            @if (getUnits(result.unit_distributions) != 0) {
              <span class="value" [transloco]="'poolUnitsDist.UNIT'"></span>
            }
          </div>
        </div>
      }
    </div>
  </div>
}

@if (leg.official === false &&
     (leg.type_code === 'HOME_CORNERS_OU' ||
      leg.type_code === 'AWAY_CORNERS_OU' ||
      leg.type_code === 'TOT_CORNERS_OU' ||
      leg.type_code === 'TOT_CARDS_OU' ||
      leg.type_code === 'OVER_UNDER')) {
  <div class="units">
    <div class="unit-selections-2 sep">
      @for (result of leg.selections | orderBy:'display_order' | reverse; track $index) {
        <div class="unit-item-2 sep">
          <div class="breakdown-score-2">
            <span [transloco]="'selections.' + result.name" [translocoParams]="{defaultValue: result.name}"></span>
          </div>
          <div class="breakdown-units-2">
            <span class="mr-0.5">{{getUnits(result.unit_distributions) | formatUnits }}</span>
            @if (getUnits(result.unit_distributions) != 0) {
              <span class="value" [transloco]="'poolUnitsDist.UNIT'"></span>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
